import * as React from 'react';
import type { HandleThunkActionCreator } from 'react-redux';
import type { InjectedFormProps } from 'redux-form';
import { reduxForm } from 'redux-form';

import type { GeneralNotifications } from 'ab-requestModels/notificationSettings.requestModel';

import { GENERAL_NOTIFICATIONS } from 'af-constants/reduxForms';

import { Button } from '@acceligentllc/storybook';

import CustomModal from 'af-components/CustomModal';
import SubmitButton from 'af-components/SubmitButton';

import type * as CompanyActions from 'af-actions/companies';

import GeneralNotificationsForm from './Form';

interface OwnProps {
	isVisible: boolean;
	toggleEdit: () => void;
	editGeneralNotifications: HandleThunkActionCreator<typeof CompanyActions.editGeneralNotifications>;
}

type Props = OwnProps & InjectedFormProps<GeneralNotifications, OwnProps>;

class GeneralNotificationsComponent extends React.PureComponent<Props> {

	editCompanyFeatureFlags = async (form: GeneralNotifications) => {
		const { toggleEdit, editGeneralNotifications } = this.props;

		await editGeneralNotifications(form);
		toggleEdit();
	};

	onClose = () => {
		const { toggleEdit, reset } = this.props;
		reset();
		toggleEdit();
	};

	render() {
		const { handleSubmit, isVisible, invalid, submitting } = this.props;

		return (
			<CustomModal
				closeModal={this.onClose}
				modalStyle="info"
				showModal={isVisible}
				size="lg"
			>
				<CustomModal.Header
					closeModal={this.onClose}
					title="Edit General Notifications"
				/>
				<CustomModal.Body padding="none">
					<GeneralNotificationsForm
						{...this.props}
						onSubmit={this.editCompanyFeatureFlags}
					/>
				</CustomModal.Body>
				<CustomModal.Footer>
					<Button
						label="Cancel"
						onClick={this.onClose}
						style="secondary"
					/>
					<SubmitButton
						disabled={invalid}
						label="Save"
						onClick={handleSubmit(this.editCompanyFeatureFlags)}
						reduxFormSubmitting={submitting}
					/>
				</CustomModal.Footer>
			</CustomModal>
		);
	}
}

export default reduxForm<GeneralNotifications, OwnProps>({ form: GENERAL_NOTIFICATIONS, enableReinitialize: true })(GeneralNotificationsComponent);
